// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import {
  Chart,
  ArcElement,
  PieController,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Legend,
  Tooltip
} from "chart.js"

import DataTable from "datatables.net-bs5"

Chart.register(
  ArcElement,
  PieController,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Legend,
  Tooltip
)

// Make Chart available globally for inline scripts
window.Chart = Chart

// Make DataTable available globally
window.DataTable = DataTable

// Initialize Bootstrap tooltips (hover + keyboard focus) on every page load.
document.addEventListener("turbo:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    if (!bootstrap.Tooltip.getInstance(el)) {
      new bootstrap.Tooltip(el)
    }
  })
})
